module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/animation-animation-reel.json
// module id = 350
// module chunks = 258544777138215